var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    [
      _c("nav-bar", { attrs: { type: "full" } }),
      _vm._v(" "),
      _c(
        "div",
        { class: ["content", { "show-guide": _vm.showGuide }] },
        [
          _c("side-bar", { on: { collapse: _vm.handleSideBarCollapse } }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dashboard",
              style: { paddingLeft: _vm.isCollapse ? ".66rem" : "2.1rem" }
            },
            [
              _vm.showHoliday ? _c("holiday-alert") : _vm._e(),
              _vm._v(" "),
              !_vm.showHoliday && _vm.$route.path.split("/")[1] !== "workorder"
                ? _c("certification-alert")
                : _vm._e(),
              _vm._v(" "),
              _vm.showNationalday ? _c("national-day-alert") : _vm._e(),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [_c("router-view", { attrs: { name: "dashboard" } })],
                1
              ),
              _vm._v(" "),
              _c("c-footer")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showGuide
        ? _c("guide", {
            on: {
              close: function($event) {
                _vm.showGuide = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("icons"),
      _vm._v(" "),
      _c("service-icons"),
      _vm._v(" "),
      _c("input", {
        staticClass: "copyUrl",
        attrs: { id: "copyUrl", type: "text", name: "copyUrl" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13d91823", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13d91823","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/MainContent.vue
// module id = 753
// module chunks = 40